import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { IChatGroup } from './types';
import { TChatGroupId } from 'app/types/rest/IRestChatGroup';
import { getByIdRest } from 'app/rest/effects/chats/group/api/getByIdRest';
import { updateAction } from '../../../../view/react_components/main/chatView/store/chatGroup/actions/updateAction';
import { chatGroupUpdateAction } from '../../../../view/react_components/main/chatView/store/chatView/actions/chatGroupUpdateAction';
import { TStatus } from 'app/types/model';
import { chatGroupDeleteAction } from '../../../../view/react_components/main/chatView/store/chatView/actions/chatGroupDeleteAction';
import { sendAuthUserRealTimeStoreAction } from 'app/view/react_components/base/helpers/realTimeHelperTS';

export const loadChatGroup = (
    id: TChatGroupId,
    isRealtime: boolean = false
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(getByIdRest(id))
            .then((group: IChatGroup)=>{
                if (group.status === TStatus.STATUS_DELETED){
                    let action  = chatGroupDeleteAction(group);
                    if (isRealtime) {
                        dispatch(sendAuthUserRealTimeStoreAction(action));
                    }
                    return  dispatch(action);
                } else {
                    let action = chatGroupUpdateAction(group.id, updateAction(group));
                    if (isRealtime) {
                        dispatch(sendAuthUserRealTimeStoreAction(action));
                    }
                    dispatch(action);
                }
                return group;
            })
    };
    return action;
};
